import { useMutation } from "@apollo/client/react";
import { useEffect, useMemo, useState } from 'react';
import 'moment/locale/es';
import { CustomButton } from '../../../components/customButton/CustomButton';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { ConexionesFilters } from './ConexionesFilters';
import { useGetConexionesRows } from '../hooks/useGetConexionesRows';
import { useGetFilters } from '../hooks/useGetFilters.js';
import { useGetConexionesColumns } from '../hooks/useGetConexionesColumns.js';
import { AUTORIZAR_CONEXIONES_MASIVO } from '../../../data/graphQL/mutations/AdminConexiones/autorizeConexionesMasivo.js';

import toast from 'react-hot-toast';

export const ConexionesContent = ({ setChildrenAction }) => {

  const [isRefetchRequired, setIsRefetchRequired] = useState(false);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const {
    delegaciones,
    delegacionOrigen,
    months,
    years,
    filters,
    handleChangeFilters,
    delegacionesLoading,
    applyClientSideFilters
  } = useGetFilters();

  const {
    rows,
    setRows,
    originalData,
    totalCount,
    loading,
    handleSearch
  } = useGetConexionesRows(
    filters,
    applyClientSideFilters,
    setIsRefetchRequired,
    delegacionOrigen
  );

  const [autorizeConexionesMasivo, { data: dataAutorizeConexionesMasivo, loading: autorizarLoading, error: dataErrorAutorizeMasivo }] = useMutation(AUTORIZAR_CONEXIONES_MASIVO);

  useEffect(() => {
    if (!dataAutorizeConexionesMasivo) return;
    toast.success('Conexiones autorizadas correctamente');
    handleSearch();
    if (dataAutorizeConexionesMasivo?.autorizarConexionesMasivo.success) {
      setRowSelectionModel([]);
    }
  }, [dataAutorizeConexionesMasivo]);

  useEffect(() => {
    if (!dataErrorAutorizeMasivo) return;
    toast.error('Error al autorizar conexiones');
  }, [dataErrorAutorizeMasivo]);

  const columns = useGetConexionesColumns(filters);

  const gridLoading = useMemo(() => delegacionesLoading || loading, [delegacionesLoading, loading]);

  useEffect(() => {
    setChildrenAction(() =>
    <div className='top-buttons'>
                <CustomButton
        className='button-header'
        disabled={!rowSelectionModel?.length || loading}
        isLoading={autorizarLoading}
        label='Autorizar conexiones'
        onClick={onAutorize}
        variant='contained' />
      
            </div>
    );
  }, [
  setChildrenAction,
  rowSelectionModel,
  autorizarLoading,
  loading]
  );

  const handleChange = (e) => {
    const { value, name } = e.target;

    if (value === filters[name]) return;

    handleChangeFilters(name, value);

    if (name === 'txtFiltro') return;
    setRows([]);
    setIsRefetchRequired(true);
  };

  const handleTextClean = () => {
    handleChangeFilters("txtFiltro", "");
    const data = applyClientSideFilters(originalData, "");
    setRows(data);
  };

  const handleTextFilter = () => {
    const data = applyClientSideFilters(
      originalData,
      filters.txtFiltro
    );
    setRows(data);
  };

  const onSelectConexion = (ids) => {
    setRowSelectionModel(ids);
  };

  const onAutorize = () => {
    const selectedContratos = rowSelectionModel.map((id) => {
      const { contrato, contratoFechaDesde, contratoFechaHasta } = rows[id - 1];
      return { idEvaluacion: contrato, fechaDesde: contratoFechaDesde, fechaHasta: contratoFechaHasta };
    });

    autorizeConexionesMasivo({
      variables: { contratos: selectedContratos }
    });
  };
  return (
    <div className='grid-container'>
      <ConexionesFilters
        delegaciones={delegaciones}
        filters={filters}
        months={months}
        years={years}
        handleChange={handleChange}
        handleTextClean={handleTextClean}
        handleTextFilter={handleTextFilter}
        handleSearch={handleSearch} />
      
      <DataGridGenerico
        checkboxSelection
        disabledSelectionAll
        onRowSelectionModelChange={onSelectConexion}
        rowSelectionModel={rowSelectionModel}
        columns={columns}
        totalCount={totalCount}
        rows={rows}
        toolbar={false}
        loading={gridLoading}
        localeText={{
          noRowsLabel: isRefetchRequired ?
          'Haz click en "Buscar" para aplicar los nuevos filtros' :
          "Sin filas"
        }} />
      
        </div>);

};